module.exports = __webpack_public_path__ + "assets/f45d806b75e0faf8a6deea3b97abe352.png";